/**
 * `fetch` 기반 `NetworkAdapter`.
 *
 * `credentials` 를 붙이지 않는다. 플레이리스트·이벤트 API 는 공개 엔드포인트이고,
 * 쿠키를 보내면 HLS·API 의 CORS 정책이 와일드카드를 쓸 수 없게 된다
 * (`Access-Control-Allow-Credentials` 와 `*` 는 함께 성립하지 않는다 — M3 에서 실측).
 *
 * **`Authorization` 헤더는 그 제약과 무관하다** — 쿠키가 아니라 명시적 헤더라
 * 와일드카드 CORS 에서도 성립한다. 서버가 `Access-Control-Allow-Headers` 에 그것을
 * 허용하고 있다(기기 등록·핸드오프가 이미 같은 헤더를 쓴다).
 */
export class FetchNetworkAdapter {
    options;
    constructor(options = {}) {
        this.options = options;
    }
    headers(base) {
        const token = this.options.authToken;
        return token ? { ...base, Authorization: `Bearer ${token}` } : base;
    }
    async get(url) {
        const res = await fetch(url, { headers: this.headers({ Accept: 'application/json' }) });
        if (!res.ok)
            throw new Error(`GET ${url} 실패: ${String(res.status)}`);
        return (await res.json());
    }
    /**
     * 이벤트 전송 전용이다. 응답 본문을 읽지 않는다 — 서버는 202 에 본문을 주지 않는다.
     * 실패는 그대로 throw 해서 `EventQueue` 가 되돌려 재시도하게 한다.
     */
    async post(url, body) {
        const res = await fetch(url, {
            method: 'POST',
            headers: this.headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(body),
        });
        if (!res.ok)
            throw new Error(`POST ${url} 실패: ${String(res.status)}`);
    }
}
//# sourceMappingURL=fetch-network.js.map